import * as types from './actionTypes';
import {ORIGINATIONS_APP_BASE_URL} from '../constants/global';
import {generateURL} from '../api/urlHelper';
import { authenticatedFetch } from '@forwardfinancing/component-library';

export function receiveLatestApprovals(json) {
  return {type: types.RECEIVE_LATEST_APPROVALS, latestApprovals: json.applications};
}

export function fetchLatestApprovals(params) {
  return dispatch => {
    return authenticatedFetch(latestApprovalsURL(params), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => {
      dispatch(receiveLatestApprovals(json));
      dispatch(handleLatestApprovalsError(false));
    })
    .catch(() => {
      dispatch(handleLatestApprovalsError(true));
    });
  };
}

export function handleLatestApprovalsError(bool) {
  return {
    type: types.HANDLE_LATEST_APPROVALS_ERROR,
    latestApprovalsError: bool
  };
}

export function latestApprovalsURL(params) {
  let url = `${ORIGINATIONS_APP_BASE_URL()}applications`;
  return generateURL(url, params);
}
